import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { baseLang, secondsToHhMmSs } from '../../lib/utils';
import { useTranslation } from 'react-i18next';
import { LessonVideo } from '../../types/Courses';
import Swal from 'sweetalert2';

export const Playlist: React.FC<{
  playlist: LessonVideo[];
  currentVideo: LessonVideo | null;
  deleteVideoHandller?: (video: LessonVideo) => void;
  onVideoSelect: (video: LessonVideo) => void;
  notificationNoVideoUrl?: (filename: string) => void;
}> = ({ playlist, onVideoSelect, deleteVideoHandller, currentVideo, notificationNoVideoUrl }) => {
  const { t, i18n } = useTranslation();
  const pageLang = baseLang(i18n.language);

  const getVideoName = (video: LessonVideo) => {
    if (pageLang === 'en') return video.filename_en || video.filename;
    if (pageLang === 'uk') return video.filename_uk || video.filename;
    if (pageLang === 'ru') return video.filename_ru || video.filename;
    return video.filename;
  };
  return (
    <Row>
      <Col>
        <h5 className="mt-4">{t('video.lessonVideos')}</h5>
        {playlist.length > 0 &&
          playlist.map((video) => {
            const videoName = getVideoName(video);
            return (
              <Col sm="9" key={video.id} className="mb-2 d-flex gap-2 align-items-center">
                <Col
                  sm="6"
                  key={video.id}
                  style={{
                    cursor: 'pointer',
                    fontWeight: video.id === currentVideo?.id ? 'bold' : 'normal',
                    textDecoration: video.id === currentVideo?.id ? 'underline' : 'none',
                  }}
                  onClick={() => {
                    if (video.videoUrl) {
                      onVideoSelect(video);
                    } else {
                      if (notificationNoVideoUrl) {
                        notificationNoVideoUrl(videoName);
                      }
                    }
                  }}
                >
                  {videoName}
                </Col>
                {deleteVideoHandller && (
                  <Col sm="2">
                    <p> {t('video.tokens', { tokens: video.transcriptionTokens })}</p>
                  </Col>
                )}
                <Col sm={deleteVideoHandller ? '3' : '5'}>
                  <p>{t('video.duration', { duration: secondsToHhMmSs(video.length) })}</p>
                </Col>
                <Col sm="1">
                  {deleteVideoHandller && (
                    <Button color="link" onClick={() => deleteVideoHandller(video)}>
                      <i className="fa fa-trash-o"></i>
                    </Button>
                  )}
                </Col>
              </Col>
            );
          })}
      </Col>
    </Row>
  );
};
